import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import moment from 'moment';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Step from '@material-ui/core/Step';
import Stepper from '@material-ui/core/Stepper';
import StepLabel from '@material-ui/core/StepLabel';
import Grid from '@material-ui/core/Grid';
import Dropzone from 'react-dropzone';
import _ from 'lodash';
import { getDialogContextValue } from '../../../redux/selectors';
import ObjectSelect from '../../Common/ObjectSelect';

import TaskProfileDrilldown from '../../TaskProfileDrilldown/index';
import ReduxDialog from '../../Common/ReduxDialog/index';
import { hideDialog, showError } from '../../../redux/actions/dialogs';
import { parseTasks } from '../../../utils/csv';
import { toJS, uuid } from '../../../utils/helper';
import {
  fetchItemTypesRoutine,
  fetchTaskFileConfigsRoutine,
  fetchTaskProfilesRoutine,
  uploadTasksRoutine
} from '../../../redux/routines';
import { TASK_UPLOAD_DIALOG } from '../../../redux/constants/dialogs';

import styles from './styles';

class TaskUploadDialog extends Component {
  state = {
    finished: false,
    stepIndex: 0,
    fileConfig: 0,
  };

  componentWillMount() {
    const { fetchTaskFileConfigs, fetchTaskProfiles, fetchItemTypes, taskFileConfigs } = this.props;

    fetchTaskFileConfigs();
    fetchTaskProfiles();
    fetchItemTypes();

    if (taskFileConfigs) {
      this.setState({
        fileConfig: taskFileConfigs[0],
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.taskFileConfigs) {
      this.setState({
        fileConfig: nextProps.taskFileConfigs[0],
      })
    }
  }

  handleNext = () => {
    const { showError } = this.props;
    const { stepIndex, fileConfig, file, taskProfile } = this.state;

    console.log('fileConfig', fileConfig, stepIndex);
    switch (stepIndex) {
      case 0:
        if (!fileConfig) {
          showError('Invalid Options', 'Please select a file format');
          return;
        }

        if (!file) {
          showError('Invalid Options', 'Please select a task list file' );
          return;
        }

        break;
      case 1:
        if (!taskProfile) {
          showError('Invalid Options', 'Please select a task profile');
          return;
        }
        break;
      default :
        break;
    }

    if (stepIndex === 1) {
      this.handleUpload();
    }

    this.setState({
      stepIndex: stepIndex + 1,
      finished: stepIndex >= 1,
    });
  };

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > 0) {
      this.setState({ stepIndex: stepIndex - 1 });
    }
  };

  handleSelectTaskProfile = (taskProfiles) => {
    this.setState({ taskProfile: taskProfiles[0] });
  };

  handleUpload = () => {
    const { job, itemTypes, uploadTasks, hideDialog } = this.props;
    const { taskProfile } = this.state;

    const tasks = this.state.tasks.map((task) => {
      return _.assign({}, task, {
        items: _.keys(taskProfile.itemTypes).reduce((res, itemTypeId) => {
          _.range(taskProfile.itemTypes[itemTypeId]).forEach(() => {
            const i = uuid();
            res[i] = {
              // id: i,
              type: itemTypes[itemTypeId],
            };
          });

          return res;
        }, {}),
      });
    });
    // const items = ;

    // const taskProfile = _.assign({}, this.state.taskProfile, {items});
    uploadTasks({ job, tasks });
    hideDialog(TASK_UPLOAD_DIALOG);
  };

  handleFileSelection = (accepted, rejected) => {
    const { showError } = this.props;
    const file = accepted[0];
    this.setState({
        file,
        uploading: true,
      }, () => {
        const reader = new FileReader();
        const dialog = this;

        reader.addEventListener('load', () => {
          return parseTasks(reader.result, this.state.fileConfig).then((data) => {
            const task = data.length > 0 ? data[0] : {};
            const headings = _.keys(task);
            console.log('headings', headings);

            dialog.setState({
              rawData: reader.result,
              tasks: data,
              // headings,
              // fieldMappings,
              uploading: false,
            });

            // this.props.onUpload({
            //   rawData: reader.result,
            //   tasks: data,
            // });
          }).catch((err) => {
            console.error(err);
            dialog.setState({
              uploading: false,
              uploadResult: 'Unable to process CSV file',
            });
          });
        }, false);

        reader.addEventListener('error', (err) => {
          console.error('onerror', err);
          showError('Upload Error', 'Unable to process file');
          dialog.setState({
            uploading: false,
          });
        });

        if (file) {
          reader.readAsText(file);
        } else {
          console.log('no file');
        }
      }
    );
  };

  getStepContent(stepIndex) {
    const { taskFileConfigs, taskProfiles } = this.props;
    const { fileConfig, taskProfile } = this.state;

    console.log('taskProfiles', taskProfiles);

    switch (stepIndex) {
      case 0:
        return (<Grid container spacing={8}>
          <Grid item xs={12}>
            <ObjectSelect
              label="File Format"
              value={fileConfig}
              onChange={(fileConfig) => this.setState({ fileConfig })}
              fullWidth
              data={taskFileConfigs || []}
              display={(fc) => fc.name}
            />
          </Grid>

          {fileConfig ? this.renderDropZone() : null}
        </Grid>);
      case 1:
        return <div>
          {/*<SelectField*/}
          {/*InputLabelProps={{shrink: true}}*/}
          {/*label="Task Profile"*/}
          {/*value={this.state.taskProfile}*/}
          {/*onChange={(event, index, taskProfile) => this.setState({ taskProfile, })}*/}
          {/*fullWidth*/}
          {/*>*/}
          {/*<MenuItem*/}
          {/*key={0}*/}
          {/*value={{}}*/}
          {/*primaryText={'None'}*/}
          {/*/>*/}
          {/*{ (this.props.taskProfiles || []).map((taskProfile) => <MenuItem*/}
          {/*key={taskProfile.id}*/}
          {/*value={taskProfile}*/}
          {/*primaryText={taskProfile.name}*/}
          {/*/>)}*/}
          {/*</SelectField>*/}
          <TaskProfileDrilldown
            allTaskProfiles={taskProfiles}
            taskProfiles={taskProfile ? [taskProfile] : []}
            onChange={this.handleSelectTaskProfile}
            selectable={false}
          />
        </div>;
      default:
        return 'You\'re a long way from home sonny jim!';
    }
  }

  renderCsvDetails() {
    const { file, tasks, uploading } = this.state;

    if (file && !uploading) {
      return (<div style={styles.csvInfo}>
        <div style={styles.csvProperties}>
          <div><b>Name:</b> {file.name}</div>
          <div><b>Modified:</b> {moment(file.lastModified).format('lll')}</div>
          <div><b>Size:</b> {Math.round(file.size / 10.24) / 100}kb</div>
        </div>
        <div style={styles.tasksInfo}>
          <div>Tasks</div>
          <div style={styles.taskCount}>{(tasks || []).length}</div>
        </div>
      </div>);
    }

    return null;
  }

  renderDropZone() {
    const { uploading } = this.state;

    return (<Dropzone
      onDrop={this.handleFileSelection}
      multiple={false}
    >
      {({ getRootProps, getInputProps, isDragActive }) => {
        // return (
        //   <div
        //     {...getRootProps()}
        //     className={classNames('dropzone', {'dropzone--isActive': isDragActive})}
        //   >
        //     <input {...getInputProps()} />
        //     {
        //       isDragActive ?
        //         <p>Drop files here...</p> :
        //         <p>Try dropping some files here, or click to select files to upload.</p>
        //     }
        //   </div>
        // )

        return (<div
          style={isDragActive ? styles.dropzoneActive : styles.dropzone} {...getRootProps()}>
          <div style={styles.uploadInstructions}>
            <div>Drag a CSV file onto here</div>
            <img alt="CSV" src="https://s3.amazonaws.com/assets.staza.io/images/csv-64.png"/>
            <div>or click to select a file</div>
          </div>

          {uploading ? <div>Uploading...</div> : this.renderCsvDetails()}
        </div>)
      }}
    </Dropzone>);
  }

  render() {
    const { stepIndex } = this.state;

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => this.props.hideDialog(TASK_UPLOAD_DIALOG)}
      >Cancel</Button>,
      <Button
        key="back"
        variant="text"
        disabled={stepIndex === 0}
        onClick={this.handlePrev}
      >Back</Button>,
      <Button
        key="next"
        variant="contained"
        color="primary"
        onClick={this.handleNext}
      >{stepIndex === 1 ? 'Upload' : 'Next'}</Button>,
    ];

    return (
      <div>
        <ReduxDialog
          name={TASK_UPLOAD_DIALOG}
          title="Upload Tasks"
          actions={actions}
          modal
          maxWidth="md"
          fullWidth
        >
          <div style={styles.container}>
            <Stepper activeStep={stepIndex}>
              <Step>
                <StepLabel>Upload Tasks</StepLabel>
              </Step>
              <Step>
                <StepLabel>Select Task Profile</StepLabel>
              </Step>
            </Stepper>

            {this.getStepContent(stepIndex)}
          </div>
        </ReduxDialog>
      </div>
    );
  }
}

TaskUploadDialog.propTypes = {
  job: PropTypes.object.isRequired,
  fetchTaskFileConfigs: PropTypes.func.isRequired,
  fetchTaskProfiles: PropTypes.func.isRequired,
  fetchItemTypes: PropTypes.func.isRequired,

  uploadTasks: PropTypes.func.isRequired,

  itemTypes: PropTypes.object,
  taskFileConfigs: PropTypes.array,
  taskProfiles: PropTypes.array,

  hideDialog: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: TASK_UPLOAD_DIALOG,  // a unique identifier for this form
})(TaskUploadDialog);

function mapStateToProps(state) {
  return {
    job: toJS(getDialogContextValue(state)(TASK_UPLOAD_DIALOG, 'job')),
    taskFileConfigs: toJS(state.getIn(['taskFileConfigs', 'taskfileconfigs', 'data'])),
    taskProfiles: toJS(state.getIn(['taskprofiles', 'taskProfiles', 'data'])),
    itemTypes: toJS(state.getIn(['itemtypes', 'itemTypes'])),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchTaskFileConfigs: fetchTaskFileConfigsRoutine.trigger,
    fetchTaskProfiles: fetchTaskProfilesRoutine.trigger,
    fetchItemTypes: fetchItemTypesRoutine.trigger,
    uploadTasks: uploadTasksRoutine.trigger,
    hideDialog,
    showError,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskUploadDialog/index.js